// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"Modal_Overlay__lVJ7g","Content":"Modal_Content__15-AG","XButton":"Modal_XButton__1-XWH"};